import type { LibraryData } from '@/core/types/library.type'

export const formatLibraryLabel = (library: LibraryData): string => library.name
